import styled from '@emotion/styled'

export const Main = styled.main`
  /* Only apply these styles for blog post types */
  ${(props) =>
    props.type === 'blog-post' &&
    `
      max-width: 1000px;
      margin-left: auto;
      margin-right: auto;

        .content {
          width: 100% !important;
          margin-left: auto !important;
        }
      }
    `}

  > section {
    position: relative;
    background-color: ${({ theme }) => theme.colors.light.lighter.hex};

    &:nth-of-type(even) {
      background-color: ${({ theme }) =>
        theme.alternateBgColor
          ? theme.colors.light.base.hex
          : theme.colors.light.lighter.hex};
    }
  }
`
